import React, { useEffect, useState } from 'react';
import { Box, Drawer, useMediaQuery, useTheme } from '@mui/material';
import Sidebar from './sections/Sidebar';
import { sections } from './sections';

const DRAWER = 240;

export default function AppDocs() {
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md')); // md = 900px
  const [selected, setSelected] = useState(0);
  const [open, setOpen] = useState(false);
  const Section = sections[selected].Component;

  useEffect(() => {
    // ao ir para desktop, usamos drawer permanente; pode fechar o temporário
    if (mdUp) setOpen(false);
  }, [mdUp]);

  const handleSelect = (i) => {
    setSelected(i);
    if (!mdUp) setOpen(false); // fecha no mobile ao escolher uma seção
  };

  return (
    <Box sx={{ display: 'flex', flex: 1, minHeight: 0 }}>
<Drawer
  variant={mdUp ? 'permanent' : 'temporary'}
  open={mdUp ? true : open}
  onClose={() => setOpen(false)}
  ModalProps={{ keepMounted: true }}
  sx={{
    width: DRAWER,
    flexShrink: 0,
    '& .MuiDrawer-paper': { width: DRAWER, boxSizing: 'border-box' },
  }}
>
  <Sidebar
    selectedIndex={selected}
    onSelect={handleSelect}
    drawerWidth={DRAWER}
    inDrawer
  />
</Drawer>

      <Box
        component="main"
        sx={{
          flex: 1,
          p: 3,
          pl: { md: `${DRAWER}px`, xs: 2 }, // reserva espaço só no desktop
          overflow: 'auto',
        }}
      >
        {/* Top bar só no mobile para abrir o menu */}
        <Box
          sx={{
            display: { xs: 'flex', md: 'none' },
            alignItems: 'center',
            justifyContent: 'space-between',
            position: 'sticky',
            top: 0,
            zIndex: theme.zIndex.appBar,
            bgcolor: 'background.paper',
            borderBottom: '1px solid',
            borderColor: 'divider',
            py: 1,
            mb: 2,
          }}
        >
          <button
            type="button"
            aria-label={open ? 'Close sections' : 'Open sections'}
            aria-expanded={open}
            onClick={() => setOpen(v => !v)}
            style={{
              background: 'transparent',
              border: 0,
              padding: '6px 10px',
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            ☰ Sections
          </button>
        </Box>

        <Section />
      </Box>
    </Box>
  );
}
